import { DialogService } from 'aurelia-dialog';
import { Container } from 'aurelia-framework';
import { UniversalEntitySelect } from '../../../dialog/universal-entity-select';
import {
    applyBsImageMediaResult,
    BS_IMAGE_FIGURE_TYPE,
    BS_IMAGE_IMG_TYPE,
    resolveBsImageFigure,
    resolveBsImageImg,
} from '../blocks/bootstrap-components/components/imageCaption';

let dialogService = Container.instance.get(DialogService);

function resolveImageTarget(component) {
    return resolveBsImageImg(component);
}

function isImageComponentType(type) {
    return (
        type === BS_IMAGE_FIGURE_TYPE ||
        type === BS_IMAGE_IMG_TYPE ||
        type === 'gallery-image'
    );
}

function getMediaItemSrc(item) {
    if (!item?.file) return '';
    return item.file.previewUrl
        ? item.file.previewUrl.replace('$width', '1500').replace('$height', '-')
        : item.file.downloadUrl;
}

export default function (editor) {
    editor.on('asset:open', () => {
        const amContainer = document.querySelector('.gjs-am-assets-cont');
        if (amContainer) {
            const existingButton = document.querySelector(
                '.custom-select-image-button'
            );
            if (existingButton) {
                existingButton.remove();
            }

            const button = document.createElement('button');
            button.innerText = 'Medien aus der Medienbibliothek auswählen';
            button.className = 'custom-select-image-button gjs-btn-prim';
            button.style.margin = '10px';
            button.addEventListener('click', () => {
                const selectedBlock = editor.getSelected();
                let conditions = {};
                if (selectedBlock) {
                    const blockType = selectedBlock.get('type');
                    if (isImageComponentType(blockType) || blockType === 'image-box') {
                        conditions = {
                            type: { $in: ['image'] },
                        };
                    } else if (blockType === 'video') {
                        conditions = {
                            type: { $in: ['video'] },
                        };
                    }
                }
                dialogService
                    .open({
                        viewModel: UniversalEntitySelect,
                        model: {
                            selectModelId: 'media-database/media-item',
                            conditions: conditions,
                        },
                    })
                    .whenClosed((data) => {
                        const items = data.output;
                        if (!items || items.length === 0) {
                            return null;
                        }
                        const blockType = selectedBlock?.get?.('type');
                        const isImageBlock = isImageComponentType(blockType);
                        const isImageBox = blockType === 'image-box';
                        const imageTarget = resolveImageTarget(selectedBlock);

                        if ((isImageBlock || isImageBox) && selectedBlock) {
                            const item = items[0];
                            const src = getMediaItemSrc(item);
                            if (isImageBox) {
                                selectedBlock.set('background-image', src);
                                selectedBlock.trigger('change:background-image');
                            } else if (imageTarget) {
                                applyBsImageMediaResult({
                                    imageTarget,
                                    figure:
                                        resolveBsImageFigure(selectedBlock) ||
                                        resolveBsImageFigure(imageTarget),
                                    result: {
                                        url: src,
                                        alt: item?.alt ?? '',
                                        title: item?.title ?? '',
                                        description: item?.description,
                                        raw: item,
                                    },
                                });
                            }
                            editor.AssetManager.close();
                        } else {
                            for (const item of items) {
                                editor.AssetManager.add({
                                    src: getMediaItemSrc(item),
                                    name: item?.title,
                                    title: item?.title,
                                    alt: item?.alt,
                                });
                            }
                        }
                    });
            });
            amContainer.prepend(button);
        }
    });

    function getHighlightedAssetMeta() {
        const asset = document.querySelector('.gjs-am-asset.gjs-am-highlight');
        if (!asset) return null;

        const titleEl = asset.querySelector('.gjs-am-name');
        const preview = asset.querySelector('.gjs-am-preview');

        const title = titleEl?.textContent?.trim() || null;

        let src = null;
        let alt = null;

        if (preview) {
            const style = preview.style.backgroundImage;
            const match = style.match(/url\(["']?(.*?)["']?\)/);

            if (match) {
                src = match[1];
                const filename = src.split('/').pop().split('?')[0];
                alt = decodeURIComponent(filename);
            }
        }

        return { title, alt, src };
    }

    const handleAssetSelect = () => {
        const selectedComponent = editor.getSelected();
        if (!selectedComponent) return;

        const componentType = selectedComponent.get?.('type');
        const isImageBlock = isImageComponentType(componentType);
        const isImageBox = componentType === 'image-box';
        const imageTarget = resolveImageTarget(selectedComponent);

        if (!isImageBlock && !isImageBox) return;

        const assets = editor.AssetManager.getAll();
        const src = getHighlightedAssetMeta()?.src;
        if (!src) return;

        const selectedAsset = assets?.models?.find((asset) => asset.id === src)?.attributes;
        if (!selectedAsset?.title && !selectedAsset?.src) return;

        if (isImageBox) {
            selectedComponent.set('background-image', src);
            selectedComponent.trigger('change:background-image');
        } else if (imageTarget) {
            imageTarget.addAttributes({
                src,
                alt: selectedAsset?.alt || '',
                title: selectedAsset?.title || '',
            });
            imageTarget.trigger('change:attributes');
        }
    };

    editor.on('asset:close', handleAssetSelect);
};
